import { render, staticRenderFns } from "./UserFormHandler.vue?vue&type=template&id=7a5c7d13&"
import script from "./UserFormHandler.vue?vue&type=script&lang=js&"
export * from "./UserFormHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports